"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StepWrapper = exports.StepTrackerContainer = exports.StepTitle = exports.StepTitleContainer = exports.StepSeparator = exports.StepNumber = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _rem = _interopRequireDefault(require("polished/lib/helpers/rem"));

var _toColorString = _interopRequireDefault(require("polished/lib/color/toColorString"));

var _designTokens = require("@decisiv/design-tokens");

var _color = _interopRequireDefault(require("@decisiv/design-tokens/lib/color"));

var _typography = _interopRequireDefault(require("@decisiv/design-tokens/lib/typography"));

var _Typography = require("../Typography");

var _Flex = _interopRequireDefault(require("../Flex"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

var stepNumberSize = _designTokens.spacing.base * 3;

var statusColor = function statusColor(active, completed) {
  if (completed) return (0, _toColorString.default)(_color.default.status.success.medium);
  if (active) return (0, _toColorString.default)(_color.default.status.information.medium);
  return (0, _toColorString.default)(_color.default.base.quarterMoon);
};

var textStatusColor = function textStatusColor(active, completed) {
  if (active || completed) return (0, _toColorString.default)(_color.default.base.snowWhite);
  return (0, _toColorString.default)(_color.default.base.alaskanHusky);
};

var backgrounStatusColor = function backgrounStatusColor(active, completed) {
  if (completed) return (0, _toColorString.default)(_color.default.status.success.medium);
  if (active) return (0, _toColorString.default)(_color.default.status.information.medium);
  return 'transparent';
};

var StepNumber = (0, _styledComponents.default)(_Flex.default).attrs({
  alignItems: 'center',
  justifyContent: 'center',
  marginX: 0.2
}).withConfig({
  displayName: "styles__StepNumber",
  componentId: "sc-1x1c7gs-0"
})(["min-width:", ";min-height:", ";text-align:center;font-size:", ";border-radius:", ";color:", ";border:", " solid ", ";background-color:", ";"], (0, _rem.default)(stepNumberSize), (0, _rem.default)(stepNumberSize), (0, _rem.default)(_typography.default.size.alias.header4), (0, _rem.default)(stepNumberSize), function (_ref) {
  var active = _ref.active,
      completed = _ref.completed;
  return textStatusColor(active, completed);
}, (0, _rem.default)(_designTokens.spacing.base * 0.2), function (_ref2) {
  var active = _ref2.active,
      completed = _ref2.completed;
  return statusColor(active, completed);
}, function (_ref3) {
  var active = _ref3.active,
      completed = _ref3.completed;
  return backgrounStatusColor(active, completed);
});
exports.StepNumber = StepNumber;

var StepSeparator = _styledComponents.default.hr.withConfig({
  displayName: "styles__StepSeparator",
  componentId: "sc-1x1c7gs-1"
})(["width:100%;height:0;border:0;border-top:", " solid ", ";border-bottom:", " solid ", ";", ""], (0, _rem.default)(_designTokens.spacing.base * 0.1), function (_ref4) {
  var active = _ref4.active,
      completed = _ref4.completed;
  return statusColor(active, completed);
}, (0, _rem.default)(_designTokens.spacing.base * 0.1), function (_ref5) {
  var active = _ref5.active,
      completed = _ref5.completed;
  return statusColor(active, completed);
}, function (_ref6) {
  var hide = _ref6.hide;
  return hide && (0, _styledComponents.css)(["visibility:hidden;"]);
});

exports.StepSeparator = StepSeparator;
var StepTitleContainer = (0, _styledComponents.default)(_Flex.default).attrs({
  marginTop: 1,
  flex: 1,
  flexDirection: 'column',
  alignItems: 'center',
  paddingX: 0.5
}).withConfig({
  displayName: "styles__StepTitleContainer",
  componentId: "sc-1x1c7gs-2"
})(["text-align:center;"]);
exports.StepTitleContainer = StepTitleContainer;
var StepTitle = (0, _styledComponents.default)(_Typography.P).withConfig({
  displayName: "styles__StepTitle",
  componentId: "sc-1x1c7gs-3"
})([""]);
exports.StepTitle = StepTitle;
var StepTrackerContainer = (0, _styledComponents.default)(_Flex.default).withConfig({
  displayName: "styles__StepTrackerContainer",
  componentId: "sc-1x1c7gs-4"
})(["width:100%;"]);
exports.StepTrackerContainer = StepTrackerContainer;
var StepWrapper = (0, _styledComponents.default)(_Flex.default).attrs({
  flex: 1,
  flexDirection: 'column'
}).withConfig({
  displayName: "styles__StepWrapper",
  componentId: "sc-1x1c7gs-5"
})([""]);
exports.StepWrapper = StepWrapper;